import React from 'react';
import { Box, Text } from '@stitch-fix/mode-react';
import { GetStartedButton, type GetStartedButtonProps } from '../GetStartedButton';
import styles from './styles.module.scss';
type CtaButtonProps = {
  ctaText?: GetStartedButtonProps['copy'];
  ctaHref?: GetStartedButtonProps['href'];
  CtaButton?: never;
} | {
  ctaText?: never;
  ctaHref?: never;
  CtaButton: React.ReactNode;
};
export type GetStartedBoxProps = {
  title?: string;
  eventLocation?: GetStartedButtonProps['eventLocation'];
} & CtaButtonProps;
export const GetStartedBox = ({
  title,
  ctaText,
  ctaHref = '/signup',
  CtaButton,
  eventLocation = 'page_end'
}: GetStartedBoxProps) => {
  return <Box className={styles.container}>
      <Text setting="title-large" as="h2" align="center" spacingBottom>
        {title ?? 'Ready to get started with\u00A0Stitch\u00A0Fix?'}
      </Text>
      {CtaButton || <GetStartedButton href={ctaHref} copy={ctaText ?? 'Take your style quiz'} eventLocation={eventLocation} variant="filled-staple" />}
    </Box>;
};